import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDropzone } from "react-dropzone";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import cuid from "cuid";
import moment from "moment";
import { useSelector } from "react-redux";
import attachementFile from "../../Images/attachment.png";
import requiredImg from "../../Images/sp.gif";
import AttachImage from "./AttachImage";
import { POPUP_FILTERS } from "../../constants/PopupFilters";
import { DisplayMsg } from "../../services/toastService";
import { keyRestrict } from "../../utils/array";
import { BASE_FILE_URL, setUrl } from "../../handlers";
import { IMAGE_REGEX } from "../../constants/regex";

const NewNote = (props) => {
  const assigneeInfo = useSelector((state) => state.DropdownList);
  const sharedData = useSelector((state) => state.SharedLayoutData);

  const [myFiles, setMyFiles] = useState([]);
  const [commentFiles, setCommentFiles] = useState([]);
  const [NoteFiles, setNoteFiles] = useState(null);
  const [NoteDetail, setNoteDetail] = useState({
    noteDate: null,
    noteType: null,
    noteId: null,
  });
  const [imageData, setImageData] = useState("");
  const [ImagePopup, setImagePopup] = useState(false);
  const [NoteTrigger, setNoteTrigger] = useState({
    btnchk: true,
    dateErr: false,
    typeErr: false,
    commentErr: false,
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        if (acceptedFiles === -1) {
          setCommentFiles(undefined);
          DisplayMsg("2", "File format not supported");
          acceptedFiles = "";
          return;
        }
        if (!IsFileSizeValid(acceptedFiles[0])) {
          DisplayMsg(
            "2",
            `File[${  acceptedFiles[0].name  }] size exceeds the allowed limit`
          );
          acceptedFiles = "";
          return;
        }
        setCommentFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
      }
      acceptedFiles.map((file) => {
        const reader = new FileReader();

        reader.onload = function (e) {
          setMyFiles((prevState) => [
            ...prevState,
            {
              id: cuid(),
              src: e.target.result,
              fileType: file.type,
              fileName: file.name,
            },
          ]);
        };
        reader.readAsDataURL(file);
        return file;
      });
    },
    [myFiles]
  );

  const IsFileSizeValid = (file) => {
    const MaxFileSize = 30000;
    if (file && MaxFileSize) {
      const filesizeMb = (file.size / (1024 * 1024)).toFixed(2);
      return Math.round(parseFloat(filesizeMb)) <= parseInt(MaxFileSize);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const Image = ({ file }) => {
    if (file.fileType.includes("image")) {
      return (
        <div className="file-item">
          <img alt={`img - ${file.id}`} src={file.src} className="d-block" />
        </div>
      );
    } 
      return <p>{file.fileName}</p>;
    
  };

  const files = myFiles.map((currentFile) => (
    <div>
      <Image file={currentFile} key={`${currentFile.id}-image`} />
      <FontAwesomeIcon
        onClick={(e) => removeFile(currentFile)}
        icon="trash"
        color="red"
        size="lg"
      />
    </div>
  ));

  const removeFile = (file) => {
    const newFiles = [...myFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
  };

  const NotePopup = (check) => {
    props.parentCallback({
      ...props.State,
      type: "note",
      render: check,
    });
  };

  useEffect(() => {
    if (props.data?.noteDetails != null) {
      LoadNoteDetail(props.data?.noteDetails);
      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        btnchk: false,
      }));
    } else {
      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        btnchk: true,
      }));
    }

    if (props.data?.attachFiles != null) {
      setNoteFiles(props.data?.attachFiles);
    }

    const keyUpHandler = (event) => {
      if (event.target.name === "noteDate") {
        if (event.srcElement.value.length <= 10) {
          if (event.srcElement.value === "") {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteDate: null,
            }));

            setNoteTrigger((triggerInfo) => ({
              ...triggerInfo,
              dateErr: true,
            }));
          } else {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteDate: event.srcElement.value,
            }));
            setNoteTrigger((triggerInfo) => ({
              ...triggerInfo,
              dateErr: false,
            }));
          }
        } else {
          const updatedDate = event.srcElement.value.slice(0, 10);
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteDate: updatedDate,
          }));
        }
      }
    };

    document.addEventListener("keyup", keyUpHandler);

    return () => {
      document.removeEventListener("keyup", keyUpHandler);
    };
  }, [props]);

  const ExtractTimeFromDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const LoadNoteDetail = (noteData) => {
    const updatedDate =
      noteData.NOTE_DATE != null ? new Date(noteData.NOTE_DATE) : "";
    const resolvedVal = noteData.RESOLVED !== "N";
    setNoteDetail((noteInfo) => ({
      ...noteInfo,
      noteType: noteData.TYPE,
      comments: noteData.COMMENTS,
      assignee: noteData.ASSIGNED_TO,
      noteDate: updatedDate,
      checked: resolvedVal,
      noteId: noteData.SEQ_NUM,
    }));

    const FromTime =
      noteData.FROM_TIME != null ? ExtractTimeFromDate(noteData.FROM_TIME) : "";
    const ToTime =
      noteData.TO_TIME != null ? ExtractTimeFromDate(noteData.TO_TIME) : "";

    if (
      FromTime &&
      FromTime.split(":").length > 1 &&
      FromTime.split(" ").length > 1
    ) {
      const fromHr = FromTime.split(":")[0];
      const NewFromTime = FromTime.split(":")[1];
      const fromMin = NewFromTime.split(" ")[0].trim();
      const fromTimeZone = NewFromTime.split(" ")[1];
      setNoteDetail((noteInfo) => ({
        ...noteInfo,
        noteFromHr: fromHr,
        noteFromMin: fromMin,
        fromTimeZone,
      }));
    }
    if (
      ToTime &&
      ToTime.split(":").length > 1 &&
      ToTime.split(" ").length > 1
    ) {
      const toHr = ToTime.split(":")[0];
      const NewToTime = ToTime.split(":")[1];
      const toMin = NewToTime.split(" ")[0].trim();
      const toTimeZone = NewToTime.split(" ")[1];
      setNoteDetail((noteInfo) => ({
        ...noteInfo,
        noteToHr: toHr,
        noteToMin: toMin,
        toTimeZone,
      }));
    }

    if (noteData.RESOLVED === "Y") {
      setNoteDetail((noteInfo) => ({
        ...noteInfo,
        checked: true,
      }));
    } else if (noteData.RESOLVED === "Y") {
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          checked: false,
        }));
      }
  };

  const SetCreateNote = (e, field) => {
    let type;
    let curVal;
    const HoursRegex = RegExp(/^\d{1,2}$|(?=^.{1,5}$)^\d+\.\d{0,1}$/);
    if (field === "noteDate") {
      type = "noteDate";
      curVal = e;
    } else if (field === "check") {
      type = "checked";
      curVal = e.target.checked;
    } else {
      type = e.target.name;
      curVal = e.target.value;
    }
    switch (type) {
      case "assignee":
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          assignee: curVal,
        }));
        break;
      case "comments":
        if (curVal === "") {
          setNoteTrigger((triggerInfo) => ({
            ...triggerInfo,
            commentErr: true,
          }));
        } else {
          setNoteTrigger((triggerInfo) => ({
            ...triggerInfo,
            commentErr: false,
          }));
        }
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          comments: curVal,
        }));
        break;

      case "noteType":
        if (curVal === "") {
          setNoteTrigger((triggerInfo) => ({
            ...triggerInfo,
            typeErr: true,
          }));
        } else {
          setNoteTrigger((triggerInfo) => ({
            ...triggerInfo,
            typeErr: false,
          }));
        }
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          noteType: curVal,
        }));
        break;

      case "noteFromMin":
        if (curVal !== "") {
          if (HoursRegex.test(curVal) && curVal < 60) {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteFromMin: curVal,
            }));
          } else {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteFromMin: "",
            }));
          }
        } else {
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteFromMin: "",
          }));
        }
        break;
      case "noteFromHr":
        if (curVal !== "") {
          if (HoursRegex.test(curVal) && curVal < 13) {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteFromHr: curVal,
            }));
            if (NoteDetail.noteFromMin == null) {
              setNoteDetail((noteInfo) => ({
                ...noteInfo,
                noteFromMin: "00",
              }));
            }
          } else {
            const prevValue =
              NoteDetail.noteFromHr != null ? NoteDetail.noteFromHr : "";
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteFromHr: prevValue,
            }));
          }
        } else {
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteFromHr: "",
          }));
        }
        break;
      case "fromAMPM":
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          fromTimeZone: curVal,
        }));
        break;
      case "noteToMin":
        if (curVal != "") {
          if (HoursRegex.test(curVal) && curVal < 60) {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteToMin: curVal,
            }));
          } else {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteToMin: "",
            }));
          }
        } else {
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteToMin: "",
          }));
        }
        break;
      case "noteToHr":
        if (curVal != "") {
          if (HoursRegex.test(curVal) && curVal < 13) {
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteToHr: curVal,
            }));
            if (NoteDetail.noteToMin == null || NoteDetail.noteToMin == "") {
              setNoteDetail((noteInfo) => ({
                ...noteInfo,
                noteToMin: "00",
              }));
            }
          } else {
            const prevValue =
              NoteDetail.noteToHr != null ? NoteDetail.noteToHr : "";
            setNoteDetail((noteInfo) => ({
              ...noteInfo,
              noteToHr: prevValue,
            }));
          }
        } else {
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteToHr: "",
          }));
        }
        break;
      case "toAMPM":
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          toTimeZone: curVal,
        }));
        break;
      case "checked":
        setNoteDetail((noteInfo) => ({
          ...noteInfo,
          checked: curVal,
        }));
        break;
      case "noteDate":
        if (curVal != null) {
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteDate: curVal,
          }));
        } else {
          setNoteDetail((noteInfo) => ({
            ...noteInfo,
            noteDate: null,
          }));
        }
        if (curVal) {
          setNoteTrigger((triggerInfo) => ({
            ...triggerInfo,
            dateErr: false,
          }));
        } else {
          setNoteTrigger((triggerInfo) => ({
            ...triggerInfo,
            dateErr: true,
          }));
        }
        break;
      default:
        break;
    }
  };

  const CreateNote = async () => {
    let noteInvalid = true;
    let fromDateTime;
    let toDateTime;
    if (
      NoteDetail.noteDate == null ||
      NoteDetail.comments === "" ||
      NoteDetail.noteType === "" ||
      NoteDetail.noteType == null
    ) {
      noteInvalid = false;
    }

    if (NoteDetail.noteDate == null) {
      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        dateErr: true,
      }));
      noteInvalid = false;
    }

    if (NoteDetail.noteType == null) {
      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        typeErr: true,
      }));
      noteInvalid = false;
    }
    if (NoteDetail.comments == null || NoteDetail.comments === "") {
      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        commentErr: true,
      }));
      noteInvalid = false;
    }

    if (noteInvalid) {
      const targetDateIs =
        NoteDetail.noteDate !== ""
          ? moment(NoteDetail.noteDate).format("MM/DD/yyyy")
          : "";

      if (
        (NoteDetail.noteFromHr && !NoteDetail.noteFromMin) ||
        (!NoteDetail.noteFromHr && NoteDetail.noteFromMin) ||
        parseFloat(NoteDetail.noteFromHr) > 12 ||
        parseFloat(NoteDetail.noteFromMin) > 59
      ) {
        DisplayMsg("2", "Invalid From time.");
        return;
      }

      if (
        (NoteDetail.noteToHr && !NoteDetail.noteToMin) ||
        (!NoteDetail.noteToHr && NoteDetail.noteToMin) ||
        parseFloat(NoteDetail.noteToHr) > 12 ||
        parseFloat(NoteDetail.noteToMin) > 59
      ) {
        DisplayMsg("2", "Invalid To time.");
        return;
      }

      if (
        NoteDetail.noteFromHr &&
        NoteDetail.noteFromMin &&
        NoteDetail.noteToHr &&
        NoteDetail.noteToMin
      ) {
        fromDateTime = `${targetDateIs} ${NoteDetail.noteFromHr}:${
          NoteDetail.noteFromMin
        } ${
          NoteDetail.fromTimeZone !== undefined ? NoteDetail.fromTimeZone : "AM"
        }`;
        toDateTime = `${targetDateIs} ${NoteDetail.noteToHr}:${
          NoteDetail.noteToMin
        } ${
          NoteDetail.toTimeZone !== undefined ? NoteDetail.toTimeZone : "AM"
        }`;

        if (Date.parse(toDateTime) < Date.parse(fromDateTime)) {
          DisplayMsg("2", "To time should be greater than From time.");
          return;
        }
      }

      const formData = new FormData();
      document.getElementById("loader").style.display = "block";
      if (commentFiles !== null) {
        for (const key of Object.keys(commentFiles)) {
          formData.append(`NOTEFILE${  key}`, commentFiles[key]);
        }
      }

      const jsonData = {
        txtNotesDate: targetDateIs,
        txtNotesFromDateTime: fromDateTime,
        txtNotesToDateTime: toDateTime,
        txtNoteComment: NoteDetail.comments,
        ddlNotesType: NoteDetail.noteType,
        ddlNotesAssignedTo: NoteDetail.assignee,
        chkNoteResolved: NoteDetail.checked ? NoteDetail.checked : false,
      };
      formData.append("jsonData", JSON.stringify(jsonData));
      formData.append("entitySeqNum", sharedData.currentClientId);
      formData.append(
        "SeqNum",
        NoteDetail.noteId != null ? NoteDetail.noteId : ""
      );

      const response = await fetch(setUrl("NOTES", "SAVE", true), {
        method: "POST",
        body: formData,
      });
      const json = await response.json();
      if (json.status) {
        DisplayMsg("1", json.Message);
        NotePopup(true);
      } else {
        DisplayMsg("2", json.Message);
      }
    }
  };

  const DownloadAttachment = async (pathFile, downloadFileName) => {
    const formData = new FormData();
    if (pathFile) {
      document.getElementById("loader").style.display = "block";
      formData.append("fileName", downloadFileName);
      formData.append("filePath", pathFile);
      const result = await fetch(
        setUrl("TICKETDETAIL", "DOWNLOAD_TASK_ATTACHMENTS"),
        {
          method: "POST",
          body: formData,
        }
      );
      const response = await result.json();
      if (response && response.status) {
        const updatedUrl = `${BASE_FILE_URL}${response.FileDirectory}&filename=${response.FileName}`;
        const a = document.createElement("a");
        a.href = updatedUrl;
        a.download = response.FileName;
        a.target = "_blank";
        a.click();

        DisplayMsg("1", "File Have been downloaded successfully");
      } else {
        DisplayMsg("2", "File can not be downloaded");
      }
    }
  };

  const ShowTicketImage = async (path, name) => {
    try {
      if (path && name) {
        const imagePath = `${path  }\\${  name}`;
        if (imagePath === "") {
          return;
        }
        document.getElementById("loader").style.display = "block";
        const formData = new FormData();
        formData.append("imagePath", imagePath);
        const result = await fetch(
          setUrl("TICKETDETAIL", "LOADIMAGEFROMSERVER"),
          {
            method: "POST",
            body: formData,
          }
        );
        const response = await result.json();
        if (response && response.Document) {
          const Base64FileBytes = response.Document;
          setImageData(Base64FileBytes);
          setImagePopup(true);
          document.getElementById("loader").style.display = "none";
        } else {
          DisplayMsg("2", "Unable to load file");
        }
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const HandleImage = (childData) => {
    setImagePopup(childData);
    setImageData("");
  };

  const AlterNoteDate = (e) => {
    if (e != null) {
      setNoteDetail((noteInfo) => ({
        ...noteInfo,
        noteDate: new Date(e),
      }));

      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        dateErr: false,
      }));
    } else {
      setNoteDetail((noteInfo) => ({
        ...noteInfo,
        noteDate: null,
      }));

      setNoteTrigger((triggerInfo) => ({
        ...triggerInfo,
        dateErr: true,
      }));
    }
  };

  const AlterDateValues = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setNoteDetail((noteInfo) => ({
        ...noteInfo,
        noteDate: e.target.value,
      }));
    }
  };

  return (
    <>
      {ImagePopup && (
        <AttachImage parentCallback={HandleImage} data={imageData} />
      )}

      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />

      <div className="overlay">
        <div className="popup">
          <div className="popup__header">
            <h3> {props.type === "create" ? "New Note" : "Note detail"} </h3>
            <span
              className="close"
              role="button"
              onClick={() => NotePopup(false)}
            >
              ×
            </span>
          </div>

          <div className="content">
            <div className="popup__body">
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <div className="field-container overflow-visible mb-0">
                    <label className="field-placeholder font-medium">
                      Date:{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />{" "}
                    </label>
                    <DatePicker
                      value={
                        NoteDetail.noteDate ? dayjs(NoteDetail.noteDate) : null
                      }
                      onChange={(data) => AlterNoteDate(data)}
                      name="noteDate"
                      className="field-input"
                      format="MM/DD/YYYY"
                      placeholder="MM/DD/YYYY"
                      onKeyDown={(e) => AlterDateValues(e)}
                    />
                  </div>
                  <p
                    className={`${
                      NoteTrigger.dateErr ? "d-block" : "d-none"
                    } text-red-400 mt-1`}
                  >
                    Required{" "}
                  </p>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Type{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />{" "}
                    </label>
                    <select
                      className="field-input"
                      name="noteType"
                      value={NoteDetail.noteType}
                      onChange={(e) => SetCreateNote(e)}
                    >
                      {POPUP_FILTERS.TYPE_OPTIONS.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                  <p
                    className={`${
                      NoteTrigger.typeErr ? "d-block" : "d-none"
                    } text-red-400 mt-1`}
                  >
                    Required{" "}
                  </p>
                  {/* ${NoteTrigger.dateErr ? 'd-block' : 'd-none'} */}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <div className="field-container textBoxValidate time-column-container ">
                    <label className="field-placeholder font-medium">
                      From Time
                    </label>
                    <input
                      className="field-input"
                      placeholder=" "
                      type="hidden"
                    />
                    <input
                      type="text"
                      className="field-input"
                      name="noteFromHr"
                      value={NoteDetail.noteFromHr}
                      onChange={(e) => SetCreateNote(e)}
                      maxLength={2}
                    />
                    <span className="field-container-colon">:</span>
                    <input
                      className="field-input"
                      type="text"
                      name="noteFromMin"
                      value={NoteDetail.noteFromMin}
                      onChange={(e) => SetCreateNote(e)}
                      maxLength={2}
                    />

                    <select
                      className="field-input"
                      name="fromAMPM"
                      value={NoteDetail.fromTimeZone}
                      onChange={(e) => SetCreateNote(e)}
                    >
                      {POPUP_FILTERS.TIMES_OPTIONS.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="field-container textBoxValidate time-column-container">
                    <label className="field-placeholder font-medium">
                      To Time
                    </label>
                    <input className="field-input" type="hidden" value="" />
                    <input
                      className="field-input"
                      type="text"
                      name="noteToHr"
                      maxLength={2}
                      value={NoteDetail.noteToHr}
                      onChange={(e) => SetCreateNote(e)}
                    />
                    <span className="field-container-colon">:</span>
                    <input
                      className="field-input"
                      type="text"
                      name="noteToMin"
                      value={NoteDetail.noteToMin}
                      onChange={(e) => SetCreateNote(e)}
                      maxLength={2}
                    />
                    <select
                      className="field-input"
                      name="toAMPM"
                      value={NoteDetail.toTimeZone}
                      onChange={(e) => SetCreateNote(e)}
                    >
                      {POPUP_FILTERS.TIMES_OPTIONS.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* {common.AssigneesData.map((item) => ( */}

              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <div className="field-container">
                    <label className="field-placeholder font-medium">
                      Assigned To
                    </label>
                    <select
                      className="field-input"
                      name="assignee"
                      onChange={(e) => SetCreateNote(e)}
                      value={NoteDetail.assignee}
                    >
                      {assigneeInfo.AssigneeList.map((item) => (
                        <option value={item.value}>{item.text}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {props?.type !== "create" ? (
                  <div className="col-md-6 col-sm-6 d-flex flex-column-reverse">
                    <div className="">
                      <input
                        type="checkbox"
                        className="field-input"
                        name="checked"
                        checked={NoteDetail.checked}
                        onChange={(e) => SetCreateNote(e, "check")}
                      />
                      <label className="ml-2 font-medium">Resolved</label>
                    </div>
                  </div>
                ) : (
                  <div className="col-md-6 col-sm-6">&nbsp;</div>
                )}
              </div>
              <div className="row">
                <div className="col-12">
                  <label className="font-medium">
                    {" "}
                    Comments:{" "}
                    <img
                      alt="Required"
                      src={requiredImg}
                      className="redboxRequired"
                    />
                  </label>
                  <textarea
                    rows="2"
                    cols="20"
                    maxLength="4000"
                    className="mb-1"
                    name="comments"
                    style={{
                      height: "90px",
                      maxHeight: "90px",
                      width: "100%",
                      float: "left",
                    }}
                    onChange={(e) => SetCreateNote(e)}
                    value={NoteDetail.comments}
                   />
                  <p
                    className={`${
                      NoteTrigger.commentErr ? "d-block" : "d-none"
                    } text-red-400 mt-2`}
                  >
                    Required{" "}
                  </p>
                </div>
              </div>
              {NoteFiles ? (
                <div className="row">
                  <div className="col-7">
                    <div style={{ textAlign: "left" }}>
                      <label className="font-medium">Attachments:</label>
                      <br />
                      <label style={{ display: "none" }}>
                        No attached image found
                      </label>
                      <section>
                        <ul>
                          {NoteFiles &&
                            NoteFiles.map((item) => item.FILE_NAME.match(IMAGE_REGEX) ? (
                                <li>
                                  <p
                                    title="View Image"
                                    printpath={item.FILE_PATH}
                                    filename={item.FILE_NAME}
                                    onClick={() =>
                                      ShowTicketImage(
                                        item.FILE_PATH,
                                        item.FILE_NAME
                                      )
                                    }
                                    className="cursor-pointer"
                                  >
                                    <img
                                      src={attachementFile}
                                      alt="attachFile"
                                      className="IconDocuments"
                                      style={{
                                        verticalAlign: "-3px",
                                        cursor: "pointer",
                                      }}
                                    />
                                    &nbsp; {item.FILE_NAME}
                                  </p>
                                </li>
                              ) : (
                                <li>
                                  <p
                                    title="Download Attachment"
                                    printpath={item.FILE_PATH}
                                    filename={item.FILE_NAME}
                                    onClick={() =>
                                      DownloadAttachment(
                                        item.FILE_PATH,
                                        item.FILE_NAME
                                      )
                                    }
                                    className="cursor-pointer"
                                  >
                                    <img
                                      src={attachementFile}
                                      alt="attachFile"
                                      className="IconDocuments"
                                      style={{
                                        verticalAlign: "-3px",
                                        cursor: "pointer",
                                      }}
                                    />
                                    &nbsp; {item.FILE_NAME}
                                  </p>
                                </li>
                              ))}
                        </ul>
                      </section>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row-form">
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <section className="mt-2">
                      <div
                        {...getRootProps({ className: "dropzone uploadInput" })}
                      >
                        <div className="dragDrop">
                          <div className="inside">
                            <input {...getInputProps()} />
                            <span className="dropzone-content">
                              <span>Drop files here</span>
                            </span>
                            <span className="ml-2">
                              <FontAwesomeIcon
                                icon="upload"
                                color="black"
                                size="sm"
                              />
                              File Upload
                            </span>
                          </div>
                        </div>
                      </div>
                      {files.length > 0 && (
                        <div className="file-list rounded mt-3">{files}</div>
                      )}
                    </section>
                  </div>
                </div>
                <span style={{ color: "red" }}>
                  File size must not exceed 30 MB
                </span>
              </div>
              <div className="row text-center">
                <div className="col-md-12 col-sm-12">
                  <label>&nbsp;</label>
                  {NoteTrigger.btnchk ? (
                    <input
                      type="button"
                      className="btnLinkGreen ClosePopup"
                      onClick={() => CreateNote()}
                      value="Create Note"
                    />
                  ) : (
                    <input
                      type="button"
                      className="btnLinkGreen ClosePopup"
                      onClick={() => CreateNote()}
                      value="Update Note"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewNote;
